import type { TravelCariFormValues } from '@polatkan/api/travel-cari';

export function emptyTravelCariForm(): TravelCariFormValues {
  return {
    firstName: '',
    lastName: '',
    companyName: '',
    tradeName: '',
    contactName: '',
    email: '',
    phone: '',
    secondaryPhone: '',
    taxId: '',
    registrationNo: '',
    website: '',
    addressLine1: '',
    city: '',
    country: '',
    notes: '',
    currency: 'TRY',
    paymentTerms: 'PREPAID',
    commissionRate: 0,
    creditLimit: 0,
    creditLimitEnabled: false,
  };
}

export function changedTravelCariFields(
  values: TravelCariFormValues,
  dirty: Partial<Record<keyof TravelCariFormValues, unknown>>
): Partial<TravelCariFormValues> {
  return Object.fromEntries(
    Object.keys(dirty)
      .filter((key) => dirty[key as keyof TravelCariFormValues])
      .map((key) => [key, values[key as keyof TravelCariFormValues]])
  );
}

export function accountErrorKey(error: unknown): string {
  const code =
    error && typeof error === 'object' && 'data' in error
      ? (error.data as { code?: string } | undefined)?.code
      : undefined;
  const message =
    error instanceof Error
      ? error.message
      : error && typeof error === 'object' && 'message' in error
        ? String(error.message)
        : '';
  if (message === 'ACCOUNT_EMAIL_EXISTS') return 'emailExists';
  if (message === 'ACCOUNT_NAME_EXISTS') return 'nameExists';
  if (message === 'ACCOUNT_CHANGED') return 'changed';
  if (message === 'ACCOUNT_TYPE_UNAVAILABLE') return 'typeUnavailable';
  if (message === 'DEV_PREVIEW_READ_ONLY') return 'readOnly';
  if (message === 'MOVEMENT_CONCURRENT_RETRY') return 'concurrentMovement';
  if (code === 'FORBIDDEN' || code === 'UNAUTHORIZED') return 'permission';
  if (code === 'BAD_REQUEST') return 'review';
  return 'saveFailed';
}
